import { render, staticRenderFns } from "./ShowGeneralConferenceTab.vue?vue&type=template&id=a23d8a16&scoped=true"
import script from "./ShowGeneralConferenceTab.vue?vue&type=script&lang=js"
export * from "./ShowGeneralConferenceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23d8a16",
  null
  
)

export default component.exports